module.exports = __webpack_public_path__ + "img/Radiateur.5bdb101d.svg";